export default __webpack_public_path__ + "static/media/KlangpolLogo1.f45221ea.jpg";